import { render, staticRenderFns } from "./game-greenfee-income.vue?vue&type=template&id=7a2d40d9&scoped=true"
import script from "./game-greenfee-income.vue?vue&type=script&lang=js"
export * from "./game-greenfee-income.vue?vue&type=script&lang=js"
import style0 from "./game-greenfee-income.vue?vue&type=style&index=0&id=7a2d40d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2d40d9",
  null
  
)

export default component.exports